import { InvoiceProjects } from './InvoiceView';
import { MyProjects } from './MyProjects';
import { TaskBreakdown } from './TaskBreakdown';
import { MyTeam } from './ProjectTeamView';

export function SideBarProjectItems() {
  return (
    <>
      <TaskBreakdown />

      <MyProjects />
      <InvoiceProjects />

      <MyTeam />
    </>
  );
}
